import { render } from "./SkeletonBlogPostList.vue?vue&type=template&id=18c69ae4"
import script from "./SkeletonBlogPostList.vue?vue&type=script&lang=js"
export * from "./SkeletonBlogPostList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__